import React from "react";

/**
 * Generic reusable Modal that fades in with a strong glass background.
 * Pass `size="xl"` for wider modals.
 */
export default function Modal({ open, onClose, children, size = "md" }) {
  if (!open) return null;
  const widths = {
    sm: "max-w-md",
    md: "max-w-xl",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
    "2xl": "max-w-5xl",
  };
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8"
      style={{ background: "rgba(0,0,0,0.65)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
      data-testid="modal-backdrop"
    >
      <div
        className={`relative w-full ${widths[size] || widths.md} max-h-[90vh] overflow-y-auto rounded-3xl`}
        style={{
          background: "rgba(15,15,18,0.96)",
          border: "1px solid rgba(255,255,255,0.10)",
          backdropFilter: "blur(28px)",
          boxShadow: "0 28px 80px rgba(0,0,0,0.8)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export const inputCls = "w-full bg-black/40 border border-white/10 rounded-xl px-3 py-2.5 text-white text-sm outline-none focus:border-[#007AFF]/50 focus:ring-1 focus:ring-[#007AFF]/40 transition";

export function Field({ label, children }) {
  return (
    <div>
      <label className="block text-[10px] uppercase tracking-[0.22em] text-white/40 mb-2">{label}</label>
      {children}
    </div>
  );
}

export const tooltipStyle = {
  contentStyle: {
    background: "rgba(15,15,18,0.94)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: 14,
    backdropFilter: "blur(20px)",
    color: "#fff",
    fontSize: 12,
  },
  labelStyle: { color: "rgba(255,255,255,0.5)" },
  // Disable the white highlight cursor that recharts adds by default
  cursor: { fill: "transparent" },
};
